module.exports = __webpack_public_path__ + "static/media/bell-finish.0f576fc3.mp3";